import React, { useEffect, useState } from 'react';
import { API } from '../api';
import { defaultUserPicture, fileToDataUrl } from '../imageUtils';

export default function Profile({ token }) {
  const [profile, setProfile] = useState(null);
  const [picture, setPicture] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const loadProfile = () => {
    fetch(`${API}/me`, { headers: { Authorization: token } })
      .then((res) => res.json())
      .then((data) => {
        setProfile(data);
        setPicture(data.profile_picture || '');
      })
      .catch(() => setError('Could not load profile.'));
  };

  useEffect(() => {
    loadProfile();
  }, [token]);

  const saveProfile = async () => {
    setError('');
    setMessage('');

    const res = await fetch(`${API}/me`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify({ profile_picture: picture || null, password })
    });

    if (!res.ok) {
      setError('Could not update profile.');
      return;
    }

    setPassword('');
    setMessage('Profile updated. Refresh the page to update the navbar picture.');
    loadProfile();
  };

  if (!profile) return <div className="container">Loading...</div>;

  return (
    <div className="container">
      <h2>My Profile</h2>
      {profile.blocked_at && <p className="blockedBanner">Your profile is blocked. You can still access old receipts.</p>}
      {error && <p className="error">{error}</p>}
      {message && <p className="success">{message}</p>}
      <p><b>Name:</b> {profile.name}</p>
      <p><b>Username:</b> {profile.username}</p>
      <p><b>Role:</b> {profile.role}</p>
      {profile.registration_number && <p><b>Reference:</b> {profile.registration_number}</p>}

      <div className="imageField">
        <img className={`imagePreview ${profile.blocked_at ? 'blockedAvatar' : ''}`} src={picture || defaultUserPicture} alt="" />
        <input
          type="file"
          accept="image/*"
          onChange={async (e) => {
            if (e.target.files?.[0]) setPicture(await fileToDataUrl(e.target.files[0]));
          }}
        />
      </div>
      {picture && <button className="secondaryButton" onClick={() => setPicture('')}>Use Default Picture</button>}

      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="New password optional"
      />
      <button onClick={saveProfile}>Save Profile</button>
    </div>
  );
}
